import React from 'react';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import ReactAI from 'react-appinsights';
import ClearCache from 'EstruturaAntiga/ClearCache';
import Loading from 'EstruturaAntiga/components/loading/Loading';
import { AuthProvider } from 'context/AuthContext';
import { MenuProvider } from 'context/MenuContext';
import { RoteiroProvider } from 'context/RoteiroContext';
import EnviarDadosNavegacao from 'EstruturaAntiga/actions/Navegacao/EnviarDadosNavegacao';

import PrivateRouteWrapper from './PrivateRouteWrapper';
import PublicRoute from './PublicRoute';
import { CriarUsuariosV2ComBloqueio, CadastroMultiplosUsuariosComBloqueio, RestaurarUsuarioComBloqueio, AlterarPlanoV2ComBloqueio } from './comBloqueio';

import Dashboard from 'EstruturaAntiga/pages/dashboard';
import AlterarDados from 'EstruturaAntiga/pages/gestaoUsuarios/alterarDados';
import AlterarSenha from 'EstruturaAntiga/pages/gestaoUsuarios/alterarSenha';
import Atendimento from 'EstruturaAntiga/pages/Atendimento';
import MicrosoftCsp from 'EstruturaAntiga/pages/microsoftCsp';
import EditarUsuariosV2 from 'EstruturaAntiga/pages/usuariosV2/editar/index.jsx';
import Error404 from 'EstruturaAntiga/pages/errorPages/404';
import Error401 from 'EstruturaAntiga/pages/errorPages/401';
import Error403 from 'EstruturaAntiga/pages/errorPages/403';
import Error503 from 'EstruturaAntiga/pages/errorPages/503';
import Home from 'EstruturaAntiga/pages/Home';
import { EsqueciMinhaSenha } from 'EstruturaAntiga/pages/EsqueciMinhaSenha';
import PesquisaSatisfacao from 'pages/Atendimentos/PesquisaSatisfacao';
import PesquisaSatisfacaoConclusao from 'pages/Atendimentos/PesquisaSatisfacao/Components/PesquisaSatisfacaoConclusao';

import EdicaoAtendimentos from 'pages/Atendimentos/Edicao';
import ListagemServico from 'pages/Servicos/Listagem';
import ListagemAtendimentos from 'pages/Atendimentos/Listagem';
import ListagemFinanceiro from 'pages/Financeiro/Listagem';
import ListagemGrupos from 'pages/Grupos/Listagem';
import ListagemUsuarios from 'pages/Usuarios/Listagem';
import Provisionamento from 'pages/Provisionamento';
import ServicoCadatro from 'pages/Servicos/Cadastro';
import ListagemTermosDeAceite from 'pages/TermosAceite/Listagem';
import RelatorioPowerBiWrapper from 'pages/Relatorio/RelatorioPowerBiWrapper';
import ListagemRestaurar from 'pages/Usuarios/ListagemRestaurar';
import AuthenticationService from 'context/AuthenticationService';


ReactAI.init({ instrumentationKey: '067b3f02-0222-4a8c-852a-e4f571da0518' });

class AppRoutes extends React.Component {
    render(){
        var history = createBrowserHistory();
        CriarEventoDeNavegacao(history);        
        return (
            <Router key={Math.random()} history={history}>
                <Switch>
                    <Route path="/provisionamento" component={Provisionamento} />
                    <Route path="/pesquisa-satisfacao" component={PesquisaSatisfacao}/>
                    <Route path="/pesquisa-satisfacao-conclusao" component={PesquisaSatisfacaoConclusao} />
                    <Route path="/401" component={Error401} />
                    <Route path="/403" component={Error403} />
                    <Route path="/404" component={Error404} />
                    <Route path="/503" component={Error503} />
                    <Redirect from="/null" to="/" />
                    <AuthProvider history={history}>
                        <MenuProvider>
                            <RoteiroProvider>
                                <ClearCache/>
                                <Loading/>
                                <Switch>
                                    <PrivateRouteWrapper path="/alterarsenha" exact component={AlterarSenha} />
                                    <PrivateRouteWrapper path="/atendimentos" exact component={Atendimento} />
                                    <PrivateRouteWrapper path="/chamados" exact component={ListagemAtendimentos} />
                                    <PrivateRouteWrapper path="/chamados/editar" exact component={EdicaoAtendimentos} />
                                    <PrivateRouteWrapper path="/dashboard" component={Dashboard} />
                                    <PrivateRouteWrapper path="/editarmeusdados" exact component={AlterarDados} />
                                    <PrivateRouteWrapper path="/financeiro" exact component={ListagemFinanceiro} />
                                    <PrivateRouteWrapper path="/grupos" exact component={ListagemGrupos} />
                                    <PrivateRouteWrapper path="/microsoft-csp" exact component={MicrosoftCsp} />
                                    <PrivateRouteWrapper path="/relatorio/:reportId" exact component={RelatorioPowerBiWrapper}/> 
                                    <PrivateRouteWrapper path="/servicos" exact component={ListagemServico} />
                                    <PrivateRouteWrapper path="/servicos/cadastro" exact component={ServicoCadatro} />
                                    <PrivateRouteWrapper path="/termosdeaceite" exact component={ListagemTermosDeAceite} />
                                    <PrivateRouteWrapper path="/usuarios" exact component={ListagemUsuarios} />
                                    <PrivateRouteWrapper path="/usuarios/alterarplano" exact component={AlterarPlanoV2ComBloqueio} />
                                    <PrivateRouteWrapper path="/usuarios/editar" exact component={EditarUsuariosV2} />
                                    <PrivateRouteWrapper path="/usuarios/novo" exact component={CriarUsuariosV2ComBloqueio} />
                                    <PrivateRouteWrapper path="/usuarios/criarmultiplos" exact component={CadastroMultiplosUsuariosComBloqueio} />
                                    <PrivateRouteWrapper path="/usuarios-excluidos" exact component={ListagemRestaurar} />
                                    <PrivateRouteWrapper path="/usuarios-excluidos/restaurar/:id" exact component={RestaurarUsuarioComBloqueio} />
                                    <PublicRoute path="/login"><Redirect to="/"/></PublicRoute> 
                                    <PublicRoute path="/esqueci-minha-senha"><EsqueciMinhaSenha/></PublicRoute>
                                    <PublicRoute path="/" exact><Home history={history}/></PublicRoute>
                                    <Route component={Error404} />
                                </Switch>
                            </RoteiroProvider>
                        </MenuProvider>
                    </AuthProvider>
                </Switch>
            </Router>
        );
    }
};

export default AppRoutes;

async function CriarEventoDeNavegacao(history) {
    await AuthenticationService.AtualizarEmCacheDadosRelacionadosAoToken()
        .then((sucesso, _) => {
            if (sucesso) {
                const contact = JSON.parse(sessionStorage.getItem('contact'));
                if (contact) {
                    history.listen(function (location) {
                        EnviarDadosNavegacao(location.pathname);
                        const gtag = window.gtag;
                        gtag('config', 'UA-44364102-8', {
                            'page_title': document.title,
                            'page_location': window.location.href,
                            'page_path': location.pathname,
                            'contact_id': contact && contact.idContact
                        });
                    });
                }
            }
        })
}

